import { render, staticRenderFns } from "./Estados.vue?vue&type=template&id=728ea4c7&scoped=true&"
import script from "./Estados.vue?vue&type=script&lang=js&"
export * from "./Estados.vue?vue&type=script&lang=js&"
import style0 from "./Estados.vue?vue&type=style&index=0&id=728ea4c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "728ea4c7",
  null
  
)

export default component.exports